import React, { useState } from 'react';
import HomePage from './pages/HomePage';
import { Toaster } from 'react-hot-toast';
import ContactModal from './components/ContactModal';
import './App.css';

function App() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="App">
      <Toaster position="top-right" />

      <HomePage onContactClick={() => setShowModal(true)} />
      {showModal && <ContactModal onClose={() => setShowModal(false)} />}
    </div>
  );
}

export default App;
